import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "tab_view_container" }
const _hoisted_2 = {
  key: 0,
  class: "tab_wrapper"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]

import { watch, computed, onActivated } from 'vue'
import { storeToRefs } from 'pinia'
import { useRouter, useRoute } from 'vue-router'
import APIRequest from '@/api'
import { useThemeColor } from '@/utils/theme'
import { useUsersStore } from '@/stores/users'
import { useSystemStore } from '@/stores/system'
import { TabData } from '@/api/Models/AppTabs'
import qs from 'qs'
import { skipExternalMall, isWeimobMall } from '@/utils/navigation'
// import { isWechat } from '@/utils/weixin'
import { useAuthStore } from '@/stores/login'


const __default__ = {
  name: 'tab'
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

_useCssVars(_ctx => ({
  "6e51c986": (_unref(themeColor))
}))

const navigateHandle = (item: TabData, navigate: () => void) => {
  if (isWeimobMall(item)) {
    skipExternalMall(item.jumpUrl)
    return ''
  }
  if (item.jumpUrl && item.jumpUrl.indexOf('#') > -1) {
    window.location.href = item.jumpUrl
    // if (isFeishu) {
    //   if (item.jumpUrl) {
    //     window.location.href = item.jumpUrl
    //   } else {
    //     navigate(getLink(item))
    //   }
    // } else {
    //   navigate(getLink(item))
    // }
  } else {
    navigate()
  }
}

const route = useRoute()
const getLink = (item: TabData) => {
  const code = item.defaultCode
  if (code === 'home') {
    return '/'
  }
  if (code === 'course') {
    return `/course?${qs.stringify(route.query)}`
  }
  if (code === 'community') {
    return '/community'
  }
  if (code === 'live') {
    return '/liveStream'
  }
  if (code === 'mine') {
    return '/my'
  }
  if (code === 'welfareMall') {
    return '/shopIndexTab'
  }
  if (code === 'lecturer') {
    return '/lecturerCenterTab'
  }
  if (code === 'task') {
    return '/taskTab'
  }
  if (code === 'study') {
    return '/myStudyTab'
  }
  // 报名
  if (code === 'signUp') {
    return '/applyCenterTab'
  }
  if (code === 'project') {
    return '/myTrainingTab'
  }
  if (code === 'exam') {
    return '/examPractiseTab'
  }
  if (code === 'survey') {
    return '/mySurveyTab'
  }
  // 面授
  if (code === 'offlineTrain') {
    return '/faceTeachingTab'
  }
  if (code === 'team') {
    return '/teamStudyListTab'
  }
  if (code === 'message') {
    return '/newsTab'
  }
  if (code === 'teaching') {
    return '/teachManage/TeachManageListTab'
  }

  if (!code && item.jumpUrl) {
    if (item.jumpUrl?.indexOf('web') > -1) {
      // window.location.href = item.jumpUrl
      return `/tabWebview/${item.id}?url=${encodeURIComponent(item.jumpUrl)}&title=${item.name}`
    } else {
      const str = process.env.VUE_APP_ENV === 'prod' ? 'share.sandstalk.com/s' : 'sands-system/s'
      if (item.jumpUrl?.indexOf(str) > -1) {
        // return `/tabCommonView?url=${encodeURIComponent(item.jumpUrl)}&title=${item.name}`
        return `/tabCommonView/${item.id}?url=${encodeURIComponent(item.jumpUrl)}&title=${item.name}`
      } else {
        // return `/tabWebview?url=${encodeURIComponent(item.jumpUrl)}&title=${item.name}`
        return `/tabWebview/${item.id}?url=${encodeURIComponent(item.jumpUrl)}&title=${item.name}`
      }
    }
  }
  return ''
}

const themeColor = useThemeColor()

const router = useRouter()
const usersStore = useUsersStore()
const authStore = useAuthStore()
const { collegeId, allTabOptions } = storeToRefs(usersStore)

const filterTabOptions = computed(() => {
  return filterByPermissions(
    allTabOptions.value.filter((item: TabData) => {
      // if (isWeimobMall(item) && isWechat) {
      //   return false
      // }
      return true
    })
  )
})
const { setTabOptions, setAllTabOptions } = usersStore

const filterByPermissions = (navigations: TabData[]) => {
  return navigations.filter((item) => {
    if (item.defaultCode === 'team' && authStore?.userAuth?.teamLearningLabel !== 1) {
      return false
    }
    if (item.defaultCode === 'teaching' && authStore?.userAuth?.teachingMgtLabel !== 1) {
      return false
    }
    return true
  })
}

const getTabs = async () => {
  const { code, data } = await APIRequest.Home.postAppTabs({
    clientType: 3,
    collegeId: collegeId.value
  })
  if (code === 1) {
    const navigations = data.navigations || []
    setAllTabOptions(navigations)
    let navigationsList: TabData[] = []
    navigationsList = filterByPermissions(navigations)
    setTabOptions(navigationsList)
    if (route.name !== 'home') {
      return
    }
    navigations.forEach((item) => {
      if (item.isDefaultPage === 1) {
        router.replace(getLink(item))
      }
    })
  } else {
    usersStore.resetState()
  }
}
const systemStore = useSystemStore()
const { lang } = storeToRefs(systemStore)
onActivated(() => {
  const needGetTabs = sessionStorage.getItem('needGetTabs')
  if (needGetTabs) {
    getTabs()
    sessionStorage.removeItem('needGetTabs')
  }
})
watch(
  [collegeId, lang],
  () => {
    if (collegeId.value !== '-1') {
      getTabs()
    }
  },
  {
    immediate: true
  }
)

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_view, null, {
      default: _withCtx(({ Component }) => [
        (_openBlock(), _createBlock(_KeepAlive, null, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
            key: _ctx.$route.fullPath
          }))
        ], 1024))
      ]),
      _: 1
    }),
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "placeholer" }, null, -1)),
    (filterTabOptions.value.length > 0)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filterTabOptions.value, (item, index) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              to: getLink(item),
              custom: "",
              key: index,
              replace: item.defaultCode !== 'live'
            }, {
              default: _withCtx(({ navigate, isExactActive }) => [
                _createElementVNode("li", {
                  class: "tab_item",
                  onClick: ($event: any) => (navigateHandle(item, navigate))
                }, [
                  _withDirectives(_createElementVNode("img", {
                    src: item.choseImgUrl,
                    class: "item_img"
                  }, null, 8, _hoisted_4), [
                    [_vShow, isExactActive]
                  ]),
                  _withDirectives(_createElementVNode("img", {
                    src: item.defaultImgUrl,
                    class: "item_img"
                  }, null, 8, _hoisted_5), [
                    [_vShow, !isExactActive]
                  ]),
                  _createElementVNode("p", {
                    class: _normalizeClass(["item_text", { item_text_active: isExactActive }])
                  }, _toDisplayString(item.name), 3)
                ], 8, _hoisted_3)
              ]),
              _: 2
            }, 1032, ["to", "replace"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})